export class EmployeeTypeModel {
    empTypeID: number;
    empTypeName: string;
    serviceTypes: Array<{id: number,name:string, vehicles: Array<any>}>;

    constructor () {
        this.empTypeID = 0;
        this.empTypeName = '';
        this.serviceTypes = [];
    }

    public static fromJson (data: any) {
        const empType = new EmployeeTypeModel;

        Object.assign(empType, {
            empTypeID: data.id,
            empTypeName: data.name,
            serviceTypes: data.service_types
        });

        return empType
    }
}